exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".honor[data-v-03c0c762]{width:100%;display:flex;justify-content:center}.honor .content[data-v-03c0c762]{width:50%}.honor .content img[data-v-03c0c762]{width:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-03c0c762","scoped":true,"hasInlineConfig":false}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/pcHonor.vue
// module id = 149
// module chunks = 0